import { Guardian } from '@tadpoles/common'
import type { Static } from 'typebox'
import { Value } from 'typebox/value'

import type {
    MappedPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

export type GuardianRecord = Static<typeof Guardian>
export type FamilyGuardianStore = PersistenceCollection<GuardianRecord, 'key'>

export const GuardianCollectionDefinition: MappedPersistenceCollectionDefinition<
    typeof Guardian,
    GuardianRecord,
    'key'
> = {
    kind: 'guardian',
    scope: 'user',
    primaryKey: 'key',
    modelSchema: Guardian,
    encode: (value) => Value.Decode(Guardian, value),
    decode: (value) => Value.Encode(Guardian, value)
}
